export default "__VITE_ASSET__C$qgwA8B__"